export default "__VITE_ASSET__B4v1$hE___"